import $ from 'cash-dom';

export default () => {
  const $car = $('.js-car-animate');

  if ($car.length) {
    const carAnimate = () => {
      const carTop = $car.offset().top;
      const carHeightStart = $car.height() / 2;
      const scrollBottom = window.pageYOffset + $(window).height();
      if (scrollBottom >= carTop + carHeightStart) {
        $car.addClass('is-active');
      }
    };

    carAnimate();

    $(window).on('scroll', () => {
      carAnimate();
    });
  }
};
